import * as React from "react"
import { FiArrowRight } from "react-icons/fi"
import {
  manualIntegrations,
  dataLayerReadyIntegrations,
} from "../../constants/data-sources"
import { Link } from "@gatsbyjs/reach-router"
import { Badge } from "gatsby-interface"
import * as styles from "./styles.css"

export function ManualIntegrations(): JSX.Element {
  return (
    <div>
      {manualIntegrations.map(item => {
        const Logo = item.logo
        const isDataLayerReady =
          item.vendor && dataLayerReadyIntegrations?.includes(item.vendor)

        return (
          <div key={item.name} className={styles.integration}>
            <span className={styles.integrationInfo}>
              {Logo && <Logo className={styles.integrationLogo} />}
              {item.name}
              {isDataLayerReady && (
                <Badge
                  size="S"
                  tone="SUCCESS"
                  textVariant="DEFAULT"
                  className={styles.integrationReady}
                >
                  Content Hub ready
                </Badge>
              )}
            </span>

            <Link
              to={`/docs${item.docsPath}`}
              className={styles.integrationDocsLink}
            >
              Setup instructions{" "}
              <FiArrowRight className={styles.integrationDocsLinkIcon} />
            </Link>
          </div>
        )
      })}
    </div>
  )
}
